import { useState } from 'react';
import { CallTray } from '@components/calls/CallTray';
import { Outlet } from 'react-router-dom';
import { Navbar } from '@components/layout/Navbar';
import { Sidebar } from '@components/layout/Sidebar';

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-surface-page">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-64">
        <Navbar onMenuToggle={() => setSidebarOpen((current) => !current)} />
        <main className="flex-1 overflow-auto">
          <div className="p-4 md:p-8">
            <Outlet />
          </div>
        </main>
        <CallTray />
      </div>
    </div>
  );
}
